<template>
  <div
    class="coupon-card"
    :class="{
      'expiring-soon': !disabled && value.nearlyExpired == 1,
      disabled: disabled,
    }"
  >
    <div
      class="coupon-card-left"
      @click="goToDetail"
    >
      <div class="coupon-value">{{ value.productAmountYuan || "0" }}元</div>
      <div
        class="coupon-condition"
        v-if="value.remark"
      >
        {{ value.remark || "" }}
      </div>
    </div>
    <div class="coupon-card-right">
      <div
        class="coupon-card-info"
        @click="goToDetail"
      >
        <div class="coupon-provider">
          <span v-if="isChargingTest">{{ value.rightName || "" }}</span>
          <div v-else>
            <img
              class="coupon-provider-icon"
              :src="providerLogo"
            >
            <span>{{ value.providerCompanyName || "" }}</span>
          </div>
        </div>
        <span
          class="coupon-text"
          :class="{ 'have-value': value.chargeCouponType }"
        >
          {{ chargeCouponType[value.chargeCouponType] || "" }}
        </span>
        <div class="coupon-deadline">{{ value.validEndDate || "" }}过期</div>
      </div>
      <div
        v-if="!disabled"
        class="coupon-card-btn"
        @click.stop="handleToUseClick"
      >
        去使用
      </div>
      <div
        v-if="isUsedList && isChargingTest"
        class="coupon-card-btn"
        @click.stop="goReport"
      >
        查报告
      </div>
    </div>
  </div>
</template>

<script>
import cardMixin from '../mixins/cardMixin.js';

export default {
  name: 'CouponCard',
  mixins: [cardMixin],
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isUsedList: {
      type: Boolean,
      default: false
    },
    isDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      config: {},
      chargeCouponType: {
        SERVICE_OFF: '服务费抵扣券',
        PAY_OFF: '服务费+电费通抵券'
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.coupon-card {
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 16px;
  background: #ffffff;
  border-radius: 20px;
  display: flex;
  align-items: stretch;
  position: relative;

  &.disabled {
    .coupon-card-left {
      background: #e6e6e6;
      .coupon-value {
        color: #787878 !important;
      }
      .coupon-condition {
        color: #787878 !important;
      }
    }
    .coupon-card-right {
      .coupon-card-info {
        .coupon-provider {
          color: #787878 !important;
        }
        .coupon-text {
          background: #787878;
          filter: grayscale(100%);
        }
      }
    }
  }
  .coupon-card-left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 200px;
    box-sizing: border-box;
    border-right: 1px dashed rgba(200, 200, 200, 1);
    height: 100%;
    background: #ffe1d9;
    border-radius: 20px 0px 0px 20px;
    height: auto;

    .coupon-value {
      text-align: center;
      font-size: 42px;
      color: #ff722c;
      font-weight: bold;
      line-height: 67px;
      margin-bottom: 4px;
      white-space: nowrap;
    }
    .coupon-condition {
      text-align: center;
      font-size: 24px;
      color: #ff722c;
      letter-spacing: 0.36px;
      font-weight: 400;
    }
  }
  .coupon-card-right {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 16px 24px;
    height: 100%;
    flex-shrink: 0;

    .coupon-card-info {
      flex: 1;
      display: flex;
      flex-direction: column;

      .coupon-provider {
        font-size: 32px;
        color: #383838;
        font-weight: 400;
        margin-bottom: 13px;
        display: flex;
        align-items: center;
        line-height: 45px;

        .coupon-provider-icon {
          width: 48px;
          height: 48px;
          object-fit: contain;
          margin-right: 4px;
        }
      }
      .coupon-text {
        font-size: 24px;
        color: #ffffff;
        letter-spacing: 0.36px;
        font-weight: 500;
        border-radius: 8px;
        display: inline-block;
        margin-bottom: 17px;
        background: transparent;
        width: max-content;

        &.have-value {
          padding: 5px 10px;
          background: #fc681d;
        }
      }
      .coupon-deadline {
        font-size: 24px;
        color: #999999;
        letter-spacing: 0.36px;
        font-weight: 400;
        line-height: 33px;
        white-space: nowrap;
      }
    }
    .coupon-card-btn {
      height: 50px;
      padding: 0 14px;
      background: #ffffff;
      border: 1px solid rgba(252, 104, 29, 1);
      border-radius: 30px;
      font-size: 24px;
      color: #fc681d;
      letter-spacing: 0.36px;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
  }
  &.expiring-soon::after {
    content: "";
    position: absolute;
    right: 0px;
    top: 0px;
    color: #1f5ae5;
    font-weight: bold;
    background-image: url("../../../assets/img/chargingVoucher/icon-expiring.png");
    background-size: cover;
    background-position: center;
    border-radius: 0px 20px 0px 20px;
    width: 72px;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
